export const APP_NAME = '慧云班人效云'

// 构建环境
export const BUILD_ENV = __ENV__ as ENV_ENUM

// 是否是线上环境
export const isPrdEnv = __ENV__ === 'formal'

// 本地开发环境
export const isLocalDev = /^(?:localhost|127\.0\.0\.1|192\.168\.\d{1,3}\.\d{1,3})$/.test(
  location.hostname
)

// 接口环境 map
export const apiEnvMap: Record<string, string> = {
  qa1: 'https://api-qa1.huiyunban.cn',
  qa2: 'https://api-qa2.huiyunban.cn',
  qa3: 'https://api-qa3.huiyunban.cn',
  qa4: 'https://api-qa4.huiyunban.cn',
  sandbox: 'https://api-sandbox.huiyunban.cn',
  formal: 'https://api.huiyunban.cn'
}

// AI助理接口环境 map
export const socketApiEnvMap: Record<string, string> = {
  qa1: 'wss://api-qa1.huiyunban.cn',
  qa2: 'wss://api-qa2.huiyunban.cn',
  qa3: 'wss://api-qa3.huiyunban.cn',
  qa4: 'wss://api-qa4.huiyunban.cn',
  sandbox: 'wss://api-sandbox.huiyunban.cn',
  formal: 'wss://api.huiyunban.cn'
}

/**
 *
 * 环境: 线上环境为 BUILD_ENV, 非线上环境为 localStorage.getItem('hyb_dev_env') || BUILD_ENV || 'qa1'
 * 非线上环境 优先级 本地存储 > 构建环境 > 默认环境
 */
export const ENV: ENV_ENUM = isPrdEnv
  ? BUILD_ENV
  : (localStorage.getItem('hyb_dev_env') as ENV_ENUM) || BUILD_ENV || 'qa1'

/**
 * 接口域名
 */
export const API_DOMAIN = apiEnvMap[ENV]

/**
 * socket 接口域名
 */
export const SOCKET_API_DOMAIN = socketApiEnvMap[ENV]

/**
 * APP web 域名
 */
export const APP_WEB_DOMAIN = isPrdEnv
  ? `https://app.huiyunban.cn`
  : `https://cloud-test.huiyunban.cn/fe-saas-h5-${ENV}`

/** 无需菜单权限的接口 */
export const WITHOUT_MENU_PERMISSION_API = [
  `/common/form_json`,
  `/system/dictionary_list`,
  `/system/dictionary_selector/group`,
  `/console/role/employee/permission`
]

// 不需要权限的页面
export const WITHOUT_PERMISSION_PAGE = [
  // 我的申请
  '/flow/apply',
  '/flow/applyForm'
]

// 页面权限映射
export const PAGE_PERMISSION_MAP: Record<string, string[]> = {
  '/entry/stay': ['/entry/modify', '/entry/confirm'],
  '/health/list': ['/health/detail']
}
